module.exports = __webpack_public_path__ + "files/8ce6820ab520041fc560e90e3ec6d5ee.mp3";